import { Injectable } from '@angular/core';
// import { io } from 'socket.io-client';
// import { environment } from 'src/environments/environment';
import { NotificationService } from './notifications.service';
import { OrderService } from './order.service';
// import { getSocketIOConnection } from '@app/shared/utility.functions';
@Injectable({ providedIn: 'root' })
export class SocketIoService {
  socket;
  constructor(private orderService: OrderService,
    private notificationsService: NotificationService) {
  }
  setupSocketConnection() {
    // this.socket =  getSocketIOConnection();
  }
  async getOrdersNotifications(user: any) {
    if (user?.userId) {
      let notificationsArr: any[] = [];
      let notifications: any[] = await this.notificationsService.getNotifications(user?.userId);
      for await (const not of notifications) {
        let seenByUserIds = not.seenByUserIds?.split(",");
        let currentUser = seenByUserIds?.find(u => Number(u) == user?.userId);
        if(!seenByUserIds || seenByUserIds[0] == "" || !currentUser){
          notificationsArr.push(not);
        }
      }
      return notificationsArr;
  }
  }
}